import React, { Fragment, useState } from 'react'
import { Col, Card, CardHeader, FormGroup, Form, CardBody, Row, Label, Table, Button, Collapse, Progress, Badge } from 'reactstrap'
import { UseListSampling } from '../../../hooks/sanitary/useListSampling';
import Datetime from 'react-datetime';
import 'moment/locale/es';
import "react-datetime/css/react-datetime.css";
import { ToolTips } from '../../../components/tooltips/ToolTips';
import { useQuatation } from '../../../hooks/quoter/useQuatation';
import { ModalListSamplings } from './ModalListSamplings';

export const IndexListSampligs = () => {

    const [filterDate, setFilterDate] = useState(true);

    const {
        date_from, date_to, obtenerDatos, handlePickerValues, validInputDate, validToInputDate, loading, listQuoter,
        countTotal, countUsed, navigateUpdate,handleListSampling,toggleModalViewListSampling, modalViewListSampling,listSamplesTypeTemp,
        code_Quoter_Temp,downdloadpdf
    } = UseListSampling(); 

     const divStyle = {
		backgroundColor: "#1e90ff" ,
		borderColor: "#46afe5",
		color: "#fff",
		textAlign: "center",
		cursor: "pointer",
		padding: "8px 16px",  
	  };

	 
    return (
        <Fragment>
            <Col sm="12" className='p-l-0'  style={{  scrollBehavior: "smooth" , transform: "scale(0.8)",    width: "125%",    transformOrigin: "top left" }}>
                <Row>
                   
                    <Col xs="12" sm="12" md="12" lg="9" xl="9" >
                        <br />
                        <Card style={{height:"450px"}} >
                            <Col sm="12">
                             <div className="table-responsive">
                                    {
                                        listQuoter.length === 0 && listQuoter === null?
                                            <div style={{ textAlign: "-webkit-center" }} >
                                                <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "50%" }} alt="" /> <br />
                                                <label className='f-w-600 f-14 badge badge-light-primary'>0 resultados de su busqueda</label>
                                            </div>
                                            :
                                            <div style={{ textAlign: "-webkit-center" }}> <br /> <br /> <br />
                                                <Table>
                                                    <thead className=" text-center">
                                                        <tr style={{ backgroundColor: "#1d5b83" }}>
                                                            <th style={{color:"#fff"}} >#</th>
                                                            <th scope="col" style={{color:"#fff"}} >Código</th>
                                                            <th scope="col" style={{color:"#fff"}} >Particular/Compañia</th>
                                                            <th scope="col" style={{color:"#fff"}} >Responsable de Muestreo</th>
                                                            <th scope="col" style={{color:"#fff"}} >Autorizo</th>
                                                            <th scope="col" style={{color:"#fff"}} >Acciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="f-13 text-center">
                                                        {
                                                            listQuoter.length >= 0 && listQuoter.map((obj, key) => {
                                                                return (
                                                                    <tr key={key} >
                                                                        <td className="pt-1 pb-1 pl-2 pr-2 align-middle">{(key + 1)}</td>
                                                                        <td className="pt-1 pb-1 pl-2 pr-2 align-middle">{obj.code}</td>
                                                                        <td className="pt-1 pb-1 pl-2 pr-2 align-middle">
                                                                            {
                                                                                obj.client_type == 1 ?
                                                                                <p>Particular/{obj.name_client}</p>
                                                                                :
                                                                                <p>Compañia/{obj.name_client}</p>
                                                                            }
                                                                        </td>
                                                                        <td className="pt-1 pb-1 pl-2 pr-2 align-middle">{obj.name_responsible}</td>
                                                                        <td className="pt-1 pb-1 pl-2 pr-2 align-middle">{obj.name_person_supervising}</td>

                                                                      
                                                                        <td className="pt-1 pb-1 pl-2 pr-2 align-middle">
                                                                          
                                                                            <Badge
                                                                                id={`tooltip-ticket-${key}`}
                                                                              
                                                                                color="dark"
                                                                                className='f-12 pointer'
                                                                                onClick={() => downdloadpdf(obj.id_quoter)}
                                                                            >
                                                                                <i className="icofont icofont-download-alt "></i>
                                                                                <ToolTips
                                                                                    placement="top"
                                                                                    dataTarget={`tooltip-ticket-${key}`}
                                                                                    dataText="Hoja de Muestreo/Campo"
                                                                                />
                                                                            </Badge>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </Table>
                                            </div>
                                    }
                                </div>
                            </Col>
                               
                               
                        </Card>
                    </Col>
                    <Col sm="12" md="12" lg="3">
                        <Card>
                                                        <CardHeader className='p-3  bg-secondary'>
                                                          <i className='fa fa-filter fIconFilter f-20 '></i>
                                                          <label className='f-14'>Filtros de Busqueda</label>
                                                        </CardHeader>
                                                        <CardBody className='p-3'>
                                                            <Row className='pb-4'>
                                                                <Col sm="12" md="12" lg="12" className='text-center'>
                                                                </Col>         
                                                                <Col sm="12" md="12" lg="12">
                                                                <label className='f-w-600 f-12'>Fecha de incio</label>
                                                                <Datetime
                                                                    key={"date_ini"}
                                                                    inputProps={{
                                                                        placeholder: 'DD-MM-YYYY',
                                                                        name: 'date_ini',
                                                                        autoComplete: "off",
                                                                        className: "form-control form-control-sm input-air-primary"
                                                                    }}
                                                                    timeFormat={false}
                                                                    value={date_from}
                                                                    locale="es"
                                                                    isValidDate={validInputDate}
                                                                    closeOnSelect={true}
                                                                    onChange={(e) => handlePickerValues(e, "date_from")}
                                                                    dateFormat="DD-MM-YYYY"
                                                                />                                                                </Col>    
                                                                <Col sm="12" md="12" lg="12" className='pt-4'>
                                                                <label className='f-w-600 f-12'>Fecha Final</label>
                                                                 <Datetime
                                                                    key={"date_end"}
                                                                    inputProps={{
                                                                        placeholder: 'DD-MM-YYYY',
                                                                        name: 'date_end',
                                                                        autoComplete: "off",
                                                                        className: "form-control form-control-sm input-air-primary"
                                                                    }}
                                                                    timeFormat={false}
                                                                    value={date_to}
                                                                    locale="es"
                                                                    isValidDate={validToInputDate}
                                                                    closeOnSelect={true}
                                                                    onChange={(e) => handlePickerValues(e, "date_to")}
                                                                    dateFormat="DD-MM-YYYY"
                                                                />                                                                </Col>   
                                                               
                                                             
                                                                <Col sm="12" md="12" lg="12" className='pt-4'>
                                                                 <div onClick={() => obtenerDatos()} className='pointer' style={divStyle} >
                                                                Buscar
                                                                </div> 
                                                                </Col>
                                                               
                                                
                                                            </Row>
                    
                                                            
                                                        </CardBody>
                                                    </Card>
                                                    </Col>  
                </Row>
            </Col>
            <ModalListSamplings
				{
				...{
					toggleModalViewListSampling, modalViewListSampling,listSamplesTypeTemp,code_Quoter_Temp
				}
				}
			/>
        </Fragment>
        
    )
}
